export const en = {
  en: {
    logout: `logout`,
    game: `game`,
    history: `history`,
    back: `back`,
    maintenance: `maintenance`,
    maintenance_desc: `We will be back shortly`,
    play_now: `play now`,

    logout_title: `<i class="tx--logout -en"></i>`,
    alert_title: `<i class="tx--alert -en"></i>`,
    chat_title: `<i class="tx--chat -en"></i>`,

    sort: `sort`,

    //= language
    language: [
      { id: 0, name: 'en' },
      { id: 2, name: 'jp' },
      { id: 1, name: 'kr' },
      { id: 3, name: 'zh' }
    ],

    //= navigation
    home: `home`,
    popular: `popular`,
    live_games: `live games`,
    table_games: `table games`,
    slot_games: `slot games`,
    other_games: `other games`,

    //= alerts
    error: `error`,
    prompt: `are you sure?`,
    info: `info`,
    success: `success`,

    ok: `ok`,
    cancel: `cancel`,
    failed: `failed`,

    //= titles
    slot_payline: `slot payline`,
    game_provider: `game provider`,
    faq: `faq`
  }
}
